import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BranchesOutlinedSvg from "@ant-design/icons-svg/es/asn/BranchesOutlined";
import AntdIcon from "../components/AntdIcon";
var BranchesOutlined = function BranchesOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BranchesOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BranchesOutlined.displayName = 'BranchesOutlined';
}
export default /*#__PURE__*/React.forwardRef(BranchesOutlined);